import api from '../api';
import { ACCOUNT_DETAILS_STATES_ENDPOINT, ISETTINGS_DATA } from '../endpoints';

export default {
    namespaced: true,
    state() {
        return {
            settings: {
                website: {
                    address_obj: {
                        address1: null,
                        address2: null,
                        zip: null,
                        country: {
                            id: null,
                            name: '',
                            code: '',
                        },
                        state: { id: null, name: '', code: '' },
                        city: null,
                    },
                    id: 1,
                    logo_file_model: null,
                    logo_url: null,
                    public_email: '',
                    public_phone: '',
                    public_website: '',
                    title: '',
                },
                api: {
                    client: null,
                    api_key: null,
                    api_key_2: null,
                    user_id: null,
                },
                bookings: {
                    allow_subscriber_emails: null,
                    allow_turnover_day: null,
                    append_email_signature: null,
                    auto_discount_overlap: null,
                    booking_lead_time: null,
                    calendar_widget_type: null,
                    client: {
                        id: null,
                        email: null,
                        email_cc: null,
                    },
                    do_not_degrade_invoice_status: null,
                    email_signature: null,
                    guest_credit_expire_months: null,
                    limit_days_advance: null,
                    noindex: null,
                    send_emails_using_company_data: null,
                    sms_phone: null,
                    sms_validated: null,
                    tracking_header: null,
                    tracking_scripts: null,
                    weekend_days: null,
                    ga_tracking_id: null,
                    smtp_settings: [
                        {
                            id: null,
                            domain: null,
                            host: null,
                            port: 587,
                            username: null,
                            password: null,
                        },
                    ],
                },
                free_email: null,
                currencies: [],
                dateFormats: [],
                chargesTableDateFormats: [],
                localization: {
                    client: {
                        currency: {
                            code: null,
                        },
                    },
                    default_country: {
                        code: null,
                    },
                    time_format: null,
                    date_format: null,
                    timezone: {
                        id: null,
                    },
                },
                timezones: [],
                languages: [],
                inquiry: {
                    fields: [
                        {
                            choices: [],
                            description: '',
                            display_guest: null,
                            display_online: null,
                            selected_index: null,
                            title: '',
                            type: '',
                        },
                    ],
                },
            },
            countries: [],
            states: [],
            provinces: [],
            selectedCountry: 0,
            selectedState: 0,
            selectedProvince: 0,

            selectedAnswer: null,
            selectedAnswerId: null,
        };
    },
    getters: {
        website: (state) => state.settings.website,
        api: (state) => state.settings.api,
        countries: (state) => state.countries,
        bookings: (state) => state.settings.bookings,
        freeEmail: (state) => state.settings.free_email,
        states: (state) => state.states,
        provinces: (state) => state.provinces,
        selectedCountry: (state) => state.selectedCountry,
        selectedState: (state) => state.selectedState,
        selectedProvince: (state) => state.selectedProvince,
        currencies: (state) => state.settings.currencies,
        dateFormats: (state) => state.settings.dateFormats,
        chargesTableDateFormats: (state) => state.settings.chargesTableDateFormats,
        languages: (state) => state.settings.languages,
        timezones: (state) => state.settings.timezones,
        localization: (state) => state.settings.localization,
        inquiry: (state) => state.settings.inquiry,
        selectedAnswer: (state) => state.selectedAnswer,
        selectedAnswerId: (state) => state.selectedAnswerId,
    },
    mutations: {
        setSettings(state, value) {
            state.settings = value;
        },
        setCountries(state, value) {
            state.countries = value;
        },
        setBookings(state, value) {
            state.settings.bookings = value;
        },
        setWebsite(state, value) {
            state.settings.website = value;
        },
        setApi(state, value) {
            state.settings.api = value;
        },
        setStates(state, value) {
            state.states = value;
        },
        setSelectedState(state, value) {
            state.selectedState = value;
        },
        setSelectedProvince(state, value) {
            state.selectedProvince = value;
        },
        setSelectedCountry(state, value) {
            state.selectedCountry = value;
        },
        setProvinces(state, value) {
            state.provinces = value;
        },
        setCurrencies(state, value) {
            state.settings.currencies = value;
        },
        setDateFormats(state, value) {
            state.settings.dateFormats = value;
        },
        setChargesTableDateFormats(state, value) {
            state.settings.chargesTableDateFormats = value;
        },
        setLanguages(state, value) {
            state.settings.languages = value;
        },
        setTimezones(state, value) {
            state.settings.timezones = value;
        },
        setLocalization(state, value) {
            state.settings.localization = value;
        },
        setInquiry(state, value) {
            state.settings.inquiry = value;
        },
        setSelectedAnswer(state, value) {
            state.selectedAnswer = value;
        },
        setSelectedAnswerId(state, value) {
            state.selectedAnswerId = value;
        },
    },
    actions: {
        async fetchSettings({ commit, dispatch, state }) {
            const { data } = await api.get(ISETTINGS_DATA());
            const countries = data.countries.map((item) => ({
                ...item,
                text: item.name,
                value: item.id,
            }));
            const selectedCountry = data.website.address_obj?.country?.id || (countries.length && countries[0].value);

            commit('setSelectedCountry', selectedCountry);
            commit('setCountries', countries);
            await dispatch('fetchStates', selectedCountry);
            const selectedState = data.website.address_obj?.state?.id || (state.states.length && state.states[0].id);
            commit('setSelectedState', selectedState);
            await dispatch('fetchProvinces', selectedState);
            const selectedProvince =
                data.website.address_obj?.province?.id || (state.provinces.length && state.provinces[0].id);
            commit('setSelectedProvince', selectedProvince);
            const localization = data.localization;

            const currencies = data.currencies.map((item) => ({
                ...item,
                value: item.code,
                text: item.name,
            }));
            const dateFormats = data.date_formats.map((item) => ({
                value: item[0],
                text: item[1],
            }));
            const chargesTableDateFormats = [
                {
                    value: 'DEFAULT',
                    text: 'Default',
                },
            ].concat([dateFormats[dateFormats.length - 1]]);
            const languages = data.languages.map((item) => ({
                ...item,
                value: item.code,
                text: item.name,
            }));
            const timezones = data.timezone_choices.map((item) => ({
                ...item,
                text: item.description,
                value: item.id,
            }));
            const selectedAnswerId = data.inquiry.fields[0].choices.find((item) => item.order === this.selectedAnswer)
                ?.id;
            const selectedAnswer = data.inquiry.fields[0].selected_index;

            commit('setSelectedAnswer', selectedAnswer);
            commit('setSelectedAnswerId', selectedAnswerId);
            commit('setSettings', {
                ...data,
                dateFormats,
                chargesTableDateFormats,
                currencies,
                languages,
                timezones,
                localization: {
                    ...localization,
                    default_country: localization.default_country || {
                        code: 'US',
                        id: 1,
                    },
                    timezone: localization.timezone || {
                        id: 1,
                    },
                },
                inquiry: data.inquiry,
            });
        },
        async fetchProvinces({ commit }, state) {
            const { data } = await api.get('/app/province/', {
                params: {
                    state,
                },
            });
            const provinces = data.map((item) => ({
                ...item,
                value: item.id,
                text: item.name,
            }));
            commit('setProvinces', provinces);
            return provinces;
        },
        async fetchStates({ commit }, selectedCountry) {
            const { data } = await api.get(ACCOUNT_DETAILS_STATES_ENDPOINT(selectedCountry));
            const states = data.states.map((item) => ({
                ...item,
                text: item.name,
                value: item.id,
            }));
            commit('setStates', states);
            return states;
        },
    },
};
